import Avatar from 'components/base/Avatar';
import avatar57 from 'assets/img/team/40x40/57.webp';
import { Dropdown, Nav } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import {
  clearAuthSession,
  getAuthRole,
  getAuthSession
} from 'features/auth/authSession';

const NavItemsSlim = () => {
  const navigate = useNavigate();
  const role = getAuthRole();
  const session = getAuthSession();
  const displayName = session?.user.name || session?.user.email || 'User';
  const roleLabel = role === 'pharmacy' ? 'Pharmacy' : 'Locum';

  const profilePath =
    role === 'pharmacy'
      ? '/dashboard/pharmacy/profile'
      : '/dashboard/locum/profile';

  const handleLogout = () => {
    clearAuthSession();
    navigate('/auth/login', { replace: true });
  };

  return (
    <div className="navbar-nav navbar-nav-icons flex-row align-items-center gap-3">
      <Nav.Item className="d-none d-md-flex align-items-center me-1">
        <div className="d-flex flex-column align-items-end">
          <span
            className="fw-bold fs-8 text-body-emphasis font-sans-serif text-truncate mb-1"
            style={{ maxWidth: 190, lineHeight: 1.2 }}
            title={displayName}
          >
            {displayName}
          </span>
          <span className="badge badge-phoenix badge-phoenix-secondary px-2 py-1 fs-10 text-uppercase">
            {roleLabel}
          </span>
        </div>
      </Nav.Item>
      <Nav.Item>
        <Dropdown align="end" autoClose="outside">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link pe-0 py-0 lh-1"
            variant=""
          >
            <Avatar src={avatar57} size="s" />
          </Dropdown.Toggle>
          <Dropdown.Menu className="navbar-dropdown-caret py-2 shadow border">
            <Dropdown.Item as={Link} to={profilePath}>
              Profile
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Nav.Item>
    </div>
  );
};

export default NavItemsSlim;
